import styled from 'styled-components';
import { Box } from '../../../../layout/Box';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'ContentPromotionDropdown' })
    .attrs<{ disabled?: boolean }>({
        width: '100%',
    })`
        ${(props) =>
            props.disabled &&
            `
            pointer-events: none;
            opacity: 0.5;
        `}
    `;

export const ControlWrapper = styled(Box)
    .withConfig({ displayName: 'ContentPromotionDropdownControlWrapper' })
    .attrs({
        width: '100%',
        position: 'relative',
        cursor: 'pointer',
    })`
        -webkit-tap-highlight-color: transparent;
    `;

export const Control = styled(Typography)
    .withConfig({ displayName: 'ContentPromotionDropdownControl' })
    .attrs({
        py: 1.75,
        px: 2,
        borderRadius: 1.75,
        border: '1px solid var(--placeholder)',
    })``;
